import { Field, FieldLabel, PromptModal, Textarea } from '@/components'
import type { ArchivedInfringementForm } from '@/modules/infringements'
import type { PromptResolve } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useState } from 'react'

interface ArchivedInfringementPromptProps {
  initialData?: ArchivedInfringementForm

  onResolve: PromptResolve<ArchivedInfringementForm | null>
}

/** The leader's reason for archiving an infringement; one is required. */
export const ArchiveInfringementPrompt: React.FC<
  ArchivedInfringementPromptProps
> = ({ initialData = { archivedBasis: '' }, onResolve }) => {
  const translations = useTranslate({
    archiveInfringement: 'infringements.archive-infringement',
    basis: 'common.basis',
    submit: 'common.submit',
  })
  const [basis, setBasis] = useState(initialData.archivedBasis)

  return (
    <PromptModal
      title={translations.archiveInfringement}
      submitText={translations.submit}
      submitDisabled={!basis.trim()}
      className="w-[600px] rounded-2xl"
      cancelOnEscape
      onCancel={() => onResolve(null)}
      onSubmit={() => onResolve({ archivedBasis: basis.trim() })}
    >
      <Field>
        <FieldLabel>{translations.basis}</FieldLabel>
        <Textarea value={basis} rows={4} autoFocus onChange={setBasis} />
      </Field>
    </PromptModal>
  )
}
